import { TFunction } from 'i18next';
import * as yup from 'yup';

import { isEmailFormatValid } from '@/utils/regexp/validations';

export const signInSchema = (t: TFunction) => {
  return yup
    .object({
      emailAddress: yup
        .string()
        .required(
          t('validationErrors.requiredField', {
            name: t('login.email.label'),
          }),
        )
        .concat(isEmailFormatValid(t)),
      password: yup.string().required(
        t('validationErrors.requiredField', {
          name: t('login.password.label'),
        }),
      ),
    })
    .required();
};
